import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [currency, setCurrency] = useState('USD');
  const [locale, setLocale] = useState('en-US');

  // Load settings from local storage on initial load
  useEffect(() => {
    const savedCurrency = localStorage.getItem('currency');
    const savedLocale = localStorage.getItem('locale');
    if (savedCurrency) {
      setCurrency(savedCurrency);
    }
    if (savedLocale) {
      setLocale(savedLocale);
    }
  }, []);

  // Save settings to local storage whenever they change
  useEffect(() => {
    localStorage.setItem('currency', currency);
    localStorage.setItem('locale', locale);
  }, [currency, locale]);

  return (
    <SettingsContext.Provider value={{ currency, setCurrency, locale, setLocale }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
